(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile = window.matchMedia('(max-width: 760px)');
  const instances = new Map();
  const impactInstances = new Map();

  function impactBadge(row) {
    if (impactInstances.has(row)) return;
    const source = row.querySelector('[data-product-impact-provider]');
    const button = row.querySelector('[data-product-impact-open]');
    if (!source || !button) return;
    function infoControl() {
      return source.querySelector('.sprout-product-modal-icon-container, [onclick*="displaySproutModal"], button[aria-haspopup="dialog"]');
    }
    // GoodAPI inserts the badge asynchronously and may replace it on variant changes.
    function ready() { button.disabled = !infoControl(); }
    const observer = new MutationObserver(ready);
    observer.observe(source, { childList: true, subtree: true });
    button.addEventListener('click', () => {
      const control = infoControl();
      if (!control) return;
      // The provider clones its original modal into body and handles close/Escape.
      // Programmatic click keeps this compact button as the focus-return target.
      control.click();
    });
    ready();
    impactInstances.set(row, () => observer.disconnect());
  }

  function accordions(scope) {
    scope.querySelectorAll('[data-product-accordion]').forEach(details => {
      const summary = details.querySelector(':scope > summary');
      const panel = details.querySelector(':scope > [data-accordion-panel]');
      if (!summary || !panel || details.dataset.animated) return;
      details.dataset.animated = 'true';
      let target = details.open, animation = null;
      details.classList.toggle('is-open', target);
      panel.inert = !target;
      function settle(open) {
        animation?.cancel();
        animation = null;
        delete details.dataset.animating;
        details.open = open;
        details.classList.toggle('is-open', open);
        panel.style.height = '';
        panel.style.opacity = '';
        panel.inert = !open;
      }
      summary.addEventListener('click', event => {
        event.preventDefault();
        target = !target;
        const start = details.open ? panel.getBoundingClientRect().height : 0;
        const opacity = details.open ? getComputedStyle(panel).opacity : '0';
        animation?.cancel();
        details.dataset.animating = 'true';
        details.open = true;
        details.classList.toggle('is-open', target);
        panel.inert = !target;
        if (reduced() || !panel.animate) { settle(target); return; }
        const end = target ? panel.scrollHeight : 0;
        panel.style.height = start + 'px';
        animation = panel.animate([
          { height: start + 'px', opacity },
          { height: end + 'px', opacity: target ? 1 : 0 }
        ], { duration: 300, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' });
        const current = animation;
        animation.onfinish = () => { if (animation === current) settle(target); };
      });
      details.addEventListener('toggle', () => {
        if (details.dataset.animating) return;
        target = details.open;
        details.classList.toggle('is-open', target);
        panel.inert = !target;
      });
    });
  }

  function sticky(section) {
    if (instances.has(section)) return;
    const form = section.querySelector('[data-pocket-product-form]');
    const original = form?.querySelector('[data-add-button]');
    const bar = section.querySelector('[data-sticky-purchase]');
    if (!bar || !form || !original) return;
    const price = bar.querySelector('[data-sticky-price]');
    const size = bar.querySelector('[data-sticky-size]');
    const add = bar.querySelector('[data-sticky-submit]');
    let frame = 0;
    document.body.append(bar);
    function sync() {
      price.textContent = section.querySelector('[data-variant-price]')?.textContent || '';
      const select = form.querySelector('[data-variant-select]');
      const option = select?.selectedOptions[0];
      if (size && option) size.firstChild.textContent = option.textContent.replace(/\s+—.*$/, '').trim() + ' ';
      const busy = form.dataset.busy === 'true' || form.getAttribute('aria-busy') === 'true';
      add.disabled = original.disabled || busy;
      add.textContent = busy ? add.dataset.busyLabel : original.disabled ? original.dataset.soldLabel : add.dataset.readyLabel;
      schedule();
    }
    function show() {
      frame = 0;
      if (!section.isConnected) return;
      const rect = original.getBoundingClientRect();
      const drawer = document.querySelector('[data-bag-drawer]');
      const newsletter = document.querySelector('[data-newsletter]');
      const footer = document.querySelector('.device .pocket-footer, .device .policy-links');
      const footerNear = footer && footer.getBoundingClientRect().top < innerHeight;
      const keyboard = window.visualViewport && window.visualViewport.height < innerHeight * .72;
      const viewportHeight = window.visualViewport?.height || innerHeight;
      const buttonMiddle = rect.top + rect.height / 2;
      const visible = mobile.matches && buttonMiddle <= viewportHeight / 2 && !drawer?.open && (!newsletter || newsletter.hidden) && !footerNear && !keyboard;
      bar.hidden = !visible;
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(show); }
    size?.addEventListener('click', () => {
      const picker = form.querySelector('[data-variant-picker]:not([hidden]), [data-variant-fallback]:not([hidden])');
      (picker || form).scrollIntoView({ block: 'center', behavior: reduced() ? 'instant' : 'smooth' });
      const choice = picker?.querySelector('[aria-pressed="true"],select');
      choice?.focus({ preventScroll: true });
    });
    add.addEventListener('click', () => { if (!original.disabled && !form.dataset.busy) form.requestSubmit(original); });
    form.addEventListener('change', sync);
    const observer = new MutationObserver(sync);
    observer.observe(original, { attributes: true, childList: true, subtree: true });
    observer.observe(form, { attributes: true, attributeFilter: ['aria-busy', 'data-busy'] });
    const events = ['pocket:bag-opened', 'pocket:bag-closed'];
    events.forEach(name => document.addEventListener(name, schedule));
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.visualViewport?.addEventListener('resize', schedule);
    instances.set(section, () => {
      observer.disconnect(); cancelAnimationFrame(frame); bar.remove();
      form.removeEventListener('change', sync);
      events.forEach(name => document.removeEventListener(name, schedule));
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.visualViewport?.removeEventListener('resize', schedule);
    });
    sync();
  }

  function init(scope = document) {
    accordions(scope);
    scope.querySelectorAll('[data-product-impact]').forEach(impactBadge);
    scope.querySelectorAll('[data-product-section]').forEach(sticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [row, cleanup] of impactInstances) {
      if (event.target.contains(row)) { cleanup(); impactInstances.delete(row); }
    }
    for (const [section, cleanup] of instances) {
      if (event.target.contains(section)) { cleanup(); instances.delete(section); }
    }
  });
})();
